import React from 'react'
import styled from '@emotion/styled'
import { color_colors_gold, color_text_default, color_variants_gold_light } from '../../constants/colors'
import { DuplicateSpokenName } from '../../utils/menuSpokenNameDuplicates'

const alertIcon = require('../../content/images/alert-circle-yellow.svg');

interface DuplicateSpokenNamesWarningProps {
    duplicates: (DuplicateSpokenName & { itemNames?: string[] })[]
    className?: string
}

const joinNames = (names: string[]) => names.length <= 1 ? (names[0] ?? "") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

export default function DuplicateSpokenNamesWarning(props: DuplicateSpokenNamesWarningProps) {
    if (!props.duplicates?.length) return null;
    return (
        <WarningWrapper className={props.className} role="alert">
            <AlertIcon src={alertIcon} alt="" />
            <div>
                <WarningTitle>These options share a "Referred to As" name</WarningTitle>
                <WarningText>
                    Callers can't choose between options with the same name, so the assistant may send the wrong one to the POS.
                </WarningText>
                <DuplicateList>
                    {props.duplicates.map((duplicate, index) =>
                        <li key={index}>
                            {`${duplicate.groupName}: ${joinNames(duplicate.optionNames)} are ${duplicate.optionNames.length > 2 ? "all" : "both"} "${duplicate.spokenName}"`}
                            {duplicate.itemNames?.length ? ` (${joinNames(duplicate.itemNames)})` : ""}
                        </li>
                    )}
                </DuplicateList>
            </div>
        </WarningWrapper>
    )
}

const WarningWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: ${color_variants_gold_light};
    border: 1px solid ${color_colors_gold};
    border-radius: 12px;
    padding: 16px;
    margin: 16px 0;
    color: ${color_text_default};
    font-family: Muli;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
`;

const AlertIcon = styled.img`
    width: 20px;
    height: 20px;
    flex-shrink: 0;
`;

const WarningTitle = styled.p`
    font-weight: bold;
    margin: 0 0 4px 0;
`;

const WarningText = styled.p`
    margin: 0 0 8px 0;
`;

const DuplicateList = styled.ul`
    margin: 0;
    padding-left: 18px;

    li + li {
        margin-top: 4px;
    }
`;
